import React from 'react';

export function FormInput(initialValue) {
	return {
	    "aria-label" : "Default",
		"aria-describedby" :"inputGroup-sizing-default",
	}
}

export default { FormInput }